import React from "react";

interface PolicyIconProps {
  fill?: string;
  size?: string | number;
}

const PolicyIcon: React.FC<PolicyIconProps> = ({ fill = "#fff", size = "27px" }) => (
  <svg
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...(size && { width: size, height: size })}
  >
    <g clipPath="url(#clip0_7724_16859)">
      <path
        d="M13.4996 28.0001C13.1547 28.0001 12.8105 27.9539 12.4752 27.8608C11.0822 27.4743 8.35977 26.422 5.77953 23.7182C2.62075 20.4072 0.683914 15.7205 0.0235618 9.78858C-0.144474 8.28232 0.599159 6.81933 1.91618 6.06253L11.5841 0.509023C12.7656 -0.169307 14.2344 -0.170041 15.4158 0.509023L25.083 6.06253C26.4008 6.81933 27.1437 8.28158 26.9757 9.78858C26.3153 15.7205 24.3785 20.4072 21.2189 23.7182C18.6387 26.422 15.917 27.4743 14.5233 27.8608C14.1887 27.9539 13.8438 28.0001 13.4996 28.0001ZM13.4996 1.75935C13.1429 1.75935 12.7862 1.85102 12.4685 2.03362L2.80058 7.58712C2.09085 7.99485 1.69066 8.78318 1.78131 9.59498C2.39818 15.136 4.17508 19.4803 7.06265 22.5067C9.34956 24.9032 11.733 25.828 12.9505 26.1653C13.3095 26.265 13.689 26.265 14.0487 26.1653C15.2662 25.8272 17.6497 24.9032 19.9366 22.5067C22.8241 19.4803 24.601 15.1368 25.2179 9.59498C25.3086 8.78318 24.9084 7.99485 24.1986 7.58712L14.5314 2.03362C14.213 1.85102 13.8563 1.75935 13.4996 1.75935Z"
        fill={fill}
      />
      <path
        d="M12.4973 11.3337L9.62518 12.9837C9.00463 13.3401 8.62286 13.9986 8.62286 14.7114V18.0114C8.62286 18.7242 9.00537 19.3827 9.62518 19.7391L12.4973 21.3891C13.1178 21.7455 13.8821 21.7455 14.5027 21.3891L17.3747 19.7391C17.9953 19.3827 18.3771 18.7242 18.3771 18.0114V14.7114C18.3771 13.9986 17.9946 13.3401 17.374 12.9837L14.5019 11.3337C13.8814 10.9773 13.1171 10.9773 12.4965 11.3337H12.4973ZM16.8728 15.576V17.1475C16.8728 17.8603 16.4903 18.5189 15.8705 18.8753L14.5027 19.6614C13.8821 20.0178 13.1178 20.0178 12.4973 19.6614L11.1294 18.876C10.5088 18.5196 10.1271 17.8611 10.1271 17.1483V15.5768C10.1271 14.864 10.5096 14.2054 11.1294 13.849L12.4973 13.0636C13.1178 12.7072 13.8821 12.7072 14.5027 13.0636L15.8705 13.849C16.4911 14.2054 16.8736 14.864 16.8736 15.5768L16.8728 15.576Z"
        fill={fill}
      />
      <path
        d="M14.011 6.17188H12.9881C11.391 6.17188 10.0917 7.46474 10.0917 9.05386V12.7396L11.5959 11.8757V9.05386C11.5959 8.28973 12.2209 7.6686 12.9881 7.6686H14.011C14.779 7.6686 15.4032 8.29046 15.4032 9.05386V10.8205L16.9075 11.685V9.05386C16.9075 7.46474 15.6081 6.17188 14.011 6.17188Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_7724_16859">
        <rect width="27" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PolicyIcon;
